module.exports = __webpack_public_path__ + "static/img/title-dpjj.0fe9f7fe.png";